





















import { Component, Vue, Prop } from 'vue-property-decorator'
import { SlideDeckSection } from '@/store/modules/slideDeck'

@Component
export default class EditSlideDeckSection extends Vue {
  @Prop() slideDeckSection!: SlideDeckSection;

  saveChanges () {
    this.$bvModal
      .msgBoxConfirm('Are you sure you wish to save changes?', {
        size: 'sm',
        buttonSize: 'sm',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (!value) {
          return
        }
        this.$store.dispatch('saveSlideDeckSection', this.slideDeckSection).then(() => {
          this.$bvModal.hide('edit-slide-deck-section-modal')
        })
      })
  }
}
